import { TicketRedemptionCodeCategory, TicketVoucherTypePin } from '@vista/omnichannel-components-domain';
import { FieldFormatType } from '../../../../types/form/field-format-type';
export const getValidationConfig = (validationConfig, isCodeLongEnough, type) => {
    return Object.assign(Object.assign({}, validationConfig), { pin: Object.assign(Object.assign({}, validationConfig.pin), { required: type ? typeRequiresPin(type) : false }), typeId: { type: FieldFormatType.Other, required: isCodeLongEnough } });
};
const typeRequiresPin = (type) => {
    return type.category === TicketRedemptionCodeCategory.Voucher && type.pin === TicketVoucherTypePin.Required;
};
